<template>
  <div>
    <div class="container-fluid mt--7">
      <div class="card shadow mb-3">
        <div class="row">
          <div class="col-md-5 mt-4">
            <div class="form-group">
              <nav aria-label="breadcrumb">
                <ol class="breadcrumb">
                  <li class="breadcrumb-item">
                    <a href="/inicio">Início</a>
                  </li>
                  <li class="breadcrumb-item">
                    <a style="color: grey; hover: none">
                      Categoria Notícia
                    </a>
                  </li>
                </ol>
                <h3 style="color: #000; margin-left: 15px">
                  Categorias de Notícia
                </h3>
              </nav>
            </div>
          </div>
          <div class="col-md-3 offset-4 div_btn_usuario mt-6">
            <div class="form-group">
              <router-link to="/cadastrar-categoria">
                <button
                  style="margin-right: 10px"
                  type="button"
                  class="btn_add"
                >
                  Cadastrar Categoria
                </button>
              </router-link>
            </div>
          </div>
        </div>
      </div>

      <div class="card shadow div_tabela">
        <div class="row justify-content-center">
          <div class="col-11">
            <div class="table-responsive">
              <table
                class="table tablesorter table align-items-center text-center table-flush"
              >
                <thead class="thead-light" style="border: solid 5px white">
                  <th>Código</th>
                  <th>Categoria</th>
                  <th>Status</th>
                  <th>Ação</th>
                </thead>

                <tbody class="list">
                  <corpo-tabela-categoria
                    v-for="categoria in state.categorias"
                    :key="categoria.id"
                    :categoria="categoria"
                    @deletarCategoria="deletarCategoria"
                  />
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { onMounted, reactive } from "vue";
import CorpoTabelaCategoria from "../../components/CorpoTabelaCategoria";
import services from "../../services";
import { useStorage } from "vue3-storage";

export default {
  components: {
    CorpoTabelaCategoria,
  },
  setup() {
    const storage = useStorage();
    var token = storage.getStorageSync("token");
    const state = reactive({
      categorias: [],
    });
    onMounted(() => {
      fetchCategoria();
    });
    async function fetchCategoria() {
      try {
        const { data } = await services.categoria.getAll({ token });
        state.categorias = data;
      } catch (error) {
        console.log(error);
      }
    }
    async function deletarCategoria(id) {
      if (confirm("Deseja deletar esta categoria?")) {
        try {
          state.isLoading = true;
          const { data } = await services.categoria.delete({
            id: id,
            token,
          });
          console.log(data.status);
          if (data.status != 200) {
            alert("Erro ao deletar categoria.");
          } else {
            fetchCategoria();
          }
        } catch (error) {
          console.log(error);
        }
      }
    }
    return {
      state,
      deletarCategoria,
    };
  },
};
</script>

<style scoped>
table {
  color: black;
}
.div_btn_usuario {
  text-align: right;
}
.div_tabela {
  height: auto;
}
.breadcrumb {
  background: #fff;
  margin-bottom: 0;
}
a {
  color: #000;
  font-family: "PoppinsMedium";
  transition: 0.2s;
}
a:hover {
  color: #93c01f;
}
</style>